import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center gap-1.5 mb-1" }
const _hoisted_2 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "text-xs text-gray-400 mt-1"
}
const _hoisted_5 = {
  key: 1,
  class: "flex items-center flex-wrap gap-2"
}
const _hoisted_6 = { class: "text-xs text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SparklesIcon = _resolveComponent("SparklesIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            'rounded-md p-4 mb-3 border',
            _ctx.available
                ? 'bg-white border-gray-200'
                : 'bg-gradient-to-br from-royal-blue-50 to-white border-royal-blue-200'
        ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('people_block.title')), 1),
      _createVNode(_component_SparklesIcon, {
        class: "w-4 h-4 text-royal-blue-600",
        title: _ctx.$t('people_block.ai_badge'),
        "aria-label": "AI"
      }, null, 8, ["title"])
    ]),
    _createElementVNode("p", {
      class: _normalizeClass(["text-xs text-gray-600 leading-relaxed", {'mb-2': !_ctx.available}])
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t('people_block.promo_description')) + " ", 1),
      _createElementVNode("a", {
        href: _ctx.helpUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        class: "text-royal-blue-600 hover:text-royal-blue-700 hover:underline font-medium"
      }, _toDisplayString(_ctx.$t('people_block.learn_more_button')), 9, _hoisted_3)
    ], 2),
    (_ctx.available)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('people_block.promo_enable_in_settings')), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/subscription",
            class: "inline-flex items-center rounded-md bg-royal-blue-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-royal-blue-700 transition-colors"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('people_block.promo_upgrade_cta')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('people_block.promo_plan_required')), 1)
        ]))
  ], 2))
}